import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { TrendingUp, Heart, Play, Users, Globe } from "lucide-react";
import api from "@/lib/api";
import { SongCard, SectionHeader } from "@/components/SongCard";
import { PerfCard } from "./Community";

export default function Discover() {
  const [feed, setFeed] = useState(null);
  const [perfs, setPerfs] = useState([]);
  const [singers, setSingers] = useState([]);

  useEffect(() => {
    api.get("/songs/home").then(({ data }) => setFeed(data));
    api.get("/community/feed", { params: { limit: 8 } }).then(({ data }) => setPerfs(data.items));
    api.get("/community/singers").then(({ data }) => setSingers(data.items));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
      <h1 className="font-head text-4xl sm:text-5xl font-black tracking-tighter mb-2">Discover</h1>
      <p className="text-muted-foreground mb-10">Trending performances, rising singers and featured karaoke from around the globe.</p>

      <SectionHeader title="New Performances" subtitle="Freshly shared by the community" action={<Link to="/community" className="text-sm text-neon-cyan hover:underline">See all</Link>} />
      {perfs.length === 0 ? (
        <div className="card-surface rounded-2xl p-10 text-center text-muted-foreground mb-8">No public performances yet — be the first to share one!</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {perfs.map((p) => <PerfCard key={p.recording_id} perf={p} />)}
        </div>
      )}

      {singers.length > 0 && (
        <>
          <SectionHeader title="Rising Singers" subtitle="Global top voices" />
          <div className="flex gap-4 overflow-x-auto no-scrollbar pb-2 mb-14">
            {singers.map((s) => (
              <Link key={s.username} to={`/@${s.username}`} className="w-32 flex-shrink-0 text-center group">
                <div className="w-24 h-24 mx-auto rounded-full overflow-hidden border-2 border-white/10 group-hover:border-neon-cyan transition-colors bg-neon-purple/20 flex items-center justify-center">
                  {s.avatar_url ? <img src={s.avatar_url.startsWith("http") ? s.avatar_url : `${process.env.REACT_APP_BACKEND_URL}${s.avatar_url}`} className="w-full h-full object-cover" alt="" /> : <span className="text-2xl font-head font-bold">{(s.display_name || s.username)[0].toUpperCase()}</span>}
                </div>
                <p className="text-sm font-semibold mt-2 truncate">@{s.username}</p>
                <p className="text-xs text-muted-foreground">{s.followers} followers</p>
              </Link>
            ))}
          </div>
        </>
      )}

      {feed && (
        <>
          <SectionHeader title="Featured Karaoke" subtitle="Popular right now" />
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {feed.trending.map((s, i) => <SongCard key={s.song_id} song={s} index={i} />)}
          </div>
        </>
      )}
    </div>
  );
}
